module.exports = __webpack_public_path__ + "static/img/gsjs_ditu.bb516e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/gsjs_ditu.png
// module id = /4K2
// module chunks = 0